const $ = window.jQuery;

export default class MobileMenu {
    constructor(selector) {
        $(document)
            .on("click", selector, function (e) {
                e.preventDefault();
                e.stopPropagation();

                $("html").toggleClass("show-mobile-menu");
            })
            .on("click", "html", function (e) {
                $("html").removeClass("show-mobile-menu");
            })
            .on("click", ".navbar-off-canvas", function (e) {
                e.stopPropagation();
            });
    }
}
